import React, { useEffect } from 'react';

import { Modal } from 'antd';
import TMIcon from 'tm-icons-library';

import FeedAPI from '../../../../api/FeedAPI';
import { useTheme } from '../../../../context/ThemeProvider';
import { useAppSelector } from '../../../../shared/hooks';
import { tintColor } from '../../../../shared/utils';
import BookOneToOneConsultation from '../../../BookOneToOneConsultation/BookOneToOneConsultation';
import { IConsultationPendingEvent } from '../../../BookOneToOneConsultation/types';

const EventCard: React.FC<{
  event: IConsultationPendingEvent;
  onClick: () => void;
}> = ({ event, onClick }) => {
  const { colors: COLORS } = useTheme();

  const { title, bookings, noOfSlotsLimit, mango } = event;

  return (
    <div className="feed-card primary" onClick={onClick}>
      <div
        className="feed-card__icon-bar"
        style={{
          backgroundColor: tintColor(COLORS.LINK, 85),
        }}>
        <TMIcon name="videocam" color={COLORS.LINK} size={20} />
      </div>
      <div className="feed-card__details-wrapper">
        <div className="feed-card-details">
          <div className="feed-card__title">
            You've {noOfSlotsLimit - bookings} out of {noOfSlotsLimit} available
            slots for <b style={{ fontWeight: 600 }}>{title}</b> in{' '}
            <b style={{ fontWeight: 600 }}>{mango.title}</b>
          </div>
        </div>

        <div className="feed-card__arrow">
          <TMIcon name="chevron-forward" size={24} color={COLORS.ICON} />
        </div>
      </div>
    </div>
  );
};

const UnbookedSlotsForConsultation: React.FC = () => {
  const { postState, selected } = useAppSelector((state) => state.activity);

  const [events, setEvents] = React.useState<IConsultationPendingEvent[]>([]);
  const [selectedEvent, setSelectedEvent] =
    React.useState<IConsultationPendingEvent | null>(null);

  const fetchEvents = async () => {
    const resp = await FeedAPI.fetchPendingSlots();
    if (resp.status === 200 && resp.data.result) {
      const newEvents =
        resp.data.result.filter((e) => e.bookings < e.noOfSlotsLimit) || [];
      setEvents(newEvents);
    }
  };

  useEffect(() => {
    if (postState.refreshing) {
      fetchEvents();
    }
  }, [postState.refreshing]);

  useEffect(() => {
    if (selected) {
      fetchEvents();
    }
  }, [selected]);

  return (
    <>
      <div>
        {events.map((event) => (
          <EventCard
            key={event._id}
            event={event}
            onClick={() => {
              setSelectedEvent(event);
            }}
          />
        ))}
      </div>

      <Modal
        open={Boolean(selectedEvent)}
        title={null}
        footer={null}
        closable={false}
        destroyOnClose
        className="postDetailsModal">
        {selectedEvent ? (
          <BookOneToOneConsultation
            isModalVisible
            event={selectedEvent}
            handleBack={() => {
              setSelectedEvent(null);
            }}
          />
        ) : null}
      </Modal>
    </>
  );
};

export default React.memo(UnbookedSlotsForConsultation);
